import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const DEFAULT_CENTER = [48.8566, 2.3522]; // Paris fallback
const DEFAULT_ZOOM = 3;

const MapPreview = ({
  center = DEFAULT_CENTER,
  zoom = DEFAULT_ZOOM,
  className,
  interactive = true,
}) => {
  const containerRef = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;

    // Aguardar um pouco para garantir que o DOM está pronto
    const timer = setTimeout(() => {
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
      }

      try {
        mapRef.current = L.map(containerRef.current, {
          center,
          zoom,
          zoomControl: true,
          dragging: interactive,
          scrollWheelZoom: interactive,
          doubleClickZoom: interactive,
          boxZoom: interactive,
          keyboard: false,
          attributionControl: false,
          touchZoom: interactive,
          pinchZoom: interactive,
        });

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          maxZoom: 19,
        }).addTo(mapRef.current);

        // Invalidate size após inicializar
        if (mapRef.current) {
          mapRef.current.invalidateSize();
        }
      } catch (error) {
        console.error('Erro ao inicializar mapa:', error);
      }
    }, 100);

    return () => {
      clearTimeout(timer);
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
      }
    };
  }, [center, zoom, interactive]);

  return <div ref={containerRef} className={className} />;
};

export default MapPreview;
